const React = require('react');
const {
  backLocationDebounced,
} = require('../../../router');
const {
  removeOpen$,
  removeCallback$,
} = require('../../../emitters/remove');
const ButtonH = require('../../dumb/Button/H');
const ButtonI = require('../../dumb/Button/I');


function handleRemove() {
  const remove = removeCallback$.getValue();
  backLocationDebounced();
  remove();
}


module.exports = require('../../containers/PopupProviderB')(removeOpen$, () => {
  return (
    <div className="cF tc">
      <div className="f18 lh168% fw5">
        Are you sure you want to delete the selected item?
      </div>
      <div className="mt35 layoutRow fhaC fvaC mhA">
        <div className="cfx mh-8 (lt|ph8)>1">
          <div>
            <ButtonH
              onClick={backLocationDebounced}
            >Cancel</ButtonH>
          </div>
          <div>
            <ButtonI
              onClick={handleRemove}
            >Delete</ButtonI>
          </div>
        </div>
      </div>
    </div>
  );
});
